// extracted by mini-css-extract-plugin
module.exports = {"WarningButton":"WarningButton_WarningButton__2nQ8j","small":"WarningButton_small__3ZCWw"};